import axios from "axios";

import { getAuthorizationToken } from "@/auth/tokenStore";
// asyncActions.js

import { assignTodoRequest, assignTodoSuccess, assignTodoFailure } from "./actions";
export const assignTodo = (taskData) => async (dispatch) => {
  dispatch(assignTodoRequest());
  try {
    const token = getAuthorizationToken();
    const origin = process.env.REACT_APP_BACKEND_URL;

    const response = await axios.post(`${origin}/api/notes-page/add_task_note/`, taskData, {
      headers: {
        Authorization: token,
      },
    });

    dispatch(assignTodoSuccess(response.data));
    return response.data;
  } catch (error) {
    dispatch(assignTodoFailure(error.message));
  }
};
